import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import { AppVerticalProvider } from '@cred/shared/AppVerticalContext'

import SimpleCta from 'components/simple-cta'
import WidgetPage from 'components/hocs/widget-page'

const variations = {
  'compare-personal-loan-rates': 'Compare Personal Loan Rates',
  'learn-about-personal-loans': 'Learn About Personal Loans',
  'compare-rates': 'Compare Rates',
  'find-my-rate': 'Find My Rate',
  'learn-more': 'Learn More',
}
export const SimpleCtaApp = (props) => {
  const { variation } = props

  return (
    <AppVerticalProvider vertical="pl">
      <SimpleCta
        url={`${config.credibleRoot}/personal-loan-prequalification`}
        variations={variations}
        large={variations[variation]?.length > 20}
        {...props}
      />
    </AppVerticalProvider>
  )
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
}

export default WidgetPage(SimpleCtaApp)
